import { Controller } from "@hotwired/stimulus"

// This controller is specifically designed for testing flash/alert messages
// It extends the regular alert controller but prevents auto-dismissal during tests
export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 5000 },
    testMode: { type: Boolean, default: false }
  }
  
  connect() {
    console.log("Test alert controller connected");
    
    // Detect test environment
    this.isTestEnvironment = 
      window.Capybara || 
      /HeadlessChrome/.test(navigator.userAgent) || 
      this.testModeValue;
    
    // Set a data attribute for easier testing
    if (this.isTestEnvironment) {
      this.element.dataset.testConnected = "true";
    }
    
    // Only auto-dismiss if timeout is greater than zero and not in test environment
    if (this.timeoutValue > 0 && !this.isTestEnvironment) {
      this.dismissTimeout = setTimeout(() => {
        this.close()
      }, this.timeoutValue)
    }
  }
  
  disconnect() {
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout)
    }
  }
  
  close(event) {
    if (event) event.preventDefault();
    
    // Add a fade-out class for animation
    this.element.classList.add('opacity-0')
    
    // Mark the element as closing for test assertions
    this.element.dataset.alertState = "closing";
    
    // In test environment, remove immediately to avoid animation delays
    if (this.isTestEnvironment) {
      this.element.remove();
      return;
    }
    
    // Remove element after animation completes
    setTimeout(() => {
      this.element.remove()
    }, 300) // Animation duration
  }
}